import React from 'react';
import AvailableStyle from './AvailableMeals.module.css';

import Card from '../UI/Card' ;
import MealItem from './MealItem/MealItem';


const DUMMY_MEALS = [
    {
        id: 'm1',
        name: 'Sushi',
        description: 'Finest fish and veggies',
        price: 22.99
    },
        {
        id: 'm2',
        name: 'Schnitzel',
        description: 'A german specialty',
        price: 16.5
    },
        {
        id: 'm3',
        name: 'Barbecue Burger',
        description: 'American, raw, meaty',
        price: 12.99
    },
]




function AvailableMeals() {

    const mealsList = DUMMY_MEALS.map(meals => {
        return <MealItem 
                id={meals.id}
                key={meals.id} 
                name={meals.name} 
                description={meals.description} 
                price={meals.price} 
            />
    })



  return (
    <section>
        <Card>
            <ul>
                {mealsList}
            </ul>
        </Card>
    </section>
  )
}

export default AvailableMeals;